import { OnboardingFlow, OnboardingItemKey } from "../../../common/enums";
import { endpointsMetadata } from "../../../common/infrastructure/routes/endpointsMetadata";

export interface IPendingItem {
  flow: OnboardingFlow;
  itemKey: OnboardingItemKey;
}

export const onboardingQueryKey = ["onboarding-pending-items"];

export const onboardingEndpoints = {
  getPendingItems: endpointsMetadata.onboarding.getPendingItems,
  completeItem: endpointsMetadata.onboarding.completeItem,
};
